export { default } from './DevicesFragment';
